export const SurveyBuilderRouteNames = {
  default: 'survey-builder-v2',
  main: 'survey-builder-main-v2',
  analyze: 'survey-builder-analyze-v2',
  submissions: 'survey-builder-submissions-v2',
  manage: 'survey-manage',
  integrate: 'survey_integrate-v2',
}
